<template>
  <div class="wrapper">
    <label>{{ label }}</label>
    <textarea
      ref="textarea"
      :disabled="disabled"
      :value="value"
      @input="handleInput"
      @blur="blur"
      :rows="rows"
      :class="{ sizeBig: sizeBig }"
    />
    <p>{{ error }}</p>
  </div>
</template>

<style scoped>
  .wrapper > label {
    display: block;
    font-style: normal;
    font-weight: 600;
    color: var(--secondary-text-color);
  }

  .wrapper > textarea {
    width: 100%;
    box-sizing: border-box;
    margin: 10px 0 5px 0;
    padding: 10px;
    font-family: inherit;
    font-size: 1.3rem;
    color: inherit;
    background-color: var(--secondary-background-color);
    border: none;
    border-bottom: 2px solid var(--primary-color);
    border-radius: 3px;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
    outline: none;
    overflow-y: hidden;
    resize: none;
    transition-property: margin, padding, border-color, border-bottom, box-shadow;
    transition-duration: 0.3s;
  }

  .wrapper > textarea.sizeBig {
    padding: 15px 10px;
    font-size: 1.8rem;
  }

  .wrapper > textarea:focus {
    border-color: var(--secondary-color);
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1), inset 0 0 2px var(--secondary-color);
  }

  .wrapper > textarea:disabled {
    background-color: var(--secondary-background-color);
    border-bottom: none;
    cursor: text;
  }

  .wrapper > p {
    margin-top: 0;
    margin-bottom: 10px;
    color: var(--error-color);
  }

  .wrapper > p:empty::before {
    display: block;
    content: '\00a0';
  }
</style>

<script>
  export default {
    props: [
      'label',
      'disabled',
      'value',
      'input',
      'blur',
      'rows',
      'error',
      'sizeBig'
    ],
    data() {
      return {
        height: null
      };
    },
    mounted() {
      const io = new IntersectionObserver(entries => {
        if(entries[0].isIntersecting === true) {
          io.disconnect()
          window.addEventListener('resize', this.resize);
          this.resize();
        }
      }, { threshold: [0] });

      io.observe(this.$refs.textarea);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.resize);
    },
    methods: {
      resize() {
        const newHeight = Math.ceil(this.$refs.textarea.scrollHeight);

        if (this.height !== newHeight) {
          this.$refs.textarea.style.height = `${newHeight}px`;
          this.height = newHeight;
        }
      },
      handleInput(event) {
        this.input(event);
        this.resize();
      }
    }
  }
</script>
